import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ButtonPrimary from "../../components/buttons/ButtonPrimary";
import InputImage from "../../components/input/InputImage";
import { useDispatch } from "react-redux";
import { setInitialRestaurantConfig, updateRestaurantConfig } from "../../redux/actions/config";
import { setmessage, setnotification } from "../../redux/actions/styles";
import InputCheckbox from "../../components/input/InputCheckbox";
import { useNavigate } from "react-router-dom";
import SplashScreen from "../../layout/SplashScreen";
import InputText from "../../components/input/InputText";
import InputArea from "../../components/input/InputArea";
import InputSelect from "../../components/input/InputSelect";
import { stateIndia } from "../../data/stateIndia";
import { emailValidation, phoneOnChange, phoneValidation } from "../../functions/validations";
import { cityIndia } from "../../data/cityIndia";
import { getCurrentDate, getCurrentTime } from "../../functions/time";
import { v4 as uuidv4 } from "uuid";
import { stringToURL } from "../../functions/conversion";
import PopupCommon from "../../components/popups/PopupCommon";
import PopupTaxInfo from "../../components/popups/PopupTaxInfo";

const InitialSetup = () => {
  const dispatch = useDispatch();
  const { restaurantConfig } = useSelector((state) => state.config);
  const { isAuthenticated, userData } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const [clientName, setclientName] = useState("");
  const [clientPhone, setclientPhone] = useState("");
  const [clientEmail, setclientEmail] = useState("");
  const [restaurantName, setrestaurantName] = useState("");

  const [companyLogo, setcompanyLogo] = useState("");
  const [loginEmailCheckbox, setloginEmailCheckbox] = useState(false);

  const [clientNameBilling, setclientNameBilling] = useState("");
  const [companyNameBilling, setcompanyNameBilling] = useState("");
  const [restaurantNameBilling, setrestaurantNameBilling] = useState("");
  const [gstinBilling, setgstinBilling] = useState("");
  const [phoneBilling, setphoneBilling] = useState("");
  const [emailBilling, setemailBilling] = useState("");
  const [loginEmailCheckboxBilling, setloginEmailCheckboxBilling] = useState(false);
  const [stateBilling, setstateBilling] = useState("");
  const [cityBilling, setcityBilling] = useState("");
  const [pincodeBilling, setpincodeBilling] = useState("");
  const [fullAddressBilling, setfullAddressBilling] = useState("");

  const [outletLogo, setoutletLogo] = useState("");
  const [outletName, setoutletName] = useState("");
  const [outletPhone, setoutletPhone] = useState("");
  const [outletFullAddress, setoutletFullAddress] = useState("");
  const [outletCity, setoutletCity] = useState("");
  const [outletState, setoutletState] = useState("");
  const [outletPincode, setoutletPincode] = useState("");
  const [outletTax, setoutletTax] = useState("");

  const [customTax, setcustomTax] = useState(false);
  const [popupTaxInfo, setpopupTaxInfo] = useState(false);

  const [loading, setloading] = useState(true);

  async function onSave() {
    if (
      !restaurantName ||
      !clientName ||
      !phoneValidation(clientPhone) ||
      !emailValidation(clientEmail) ||
      !companyLogo ||
      !clientNameBilling ||
      !companyNameBilling ||
      !restaurantNameBilling ||
      !gstinBilling ||
      !phoneValidation(phoneBilling) ||
      !emailValidation(emailBilling) ||
      !stateBilling ||
      !cityBilling ||
      !pincodeBilling ||
      !fullAddressBilling ||
      // !outletLogo ||
      !outletName ||
      !phoneValidation(outletPhone) ||
      !outletFullAddress ||
      !outletCity ||
      !outletState ||
      !outletPincode
    ) {
      dispatch(
        setnotification({
          visible: true,
          text: "Please fill out valid credentials.",
          type: "error",
        })
      );
      return;
    }

    const data = {
      restaurantName,
      clientName,
      clientPhone,
      clientEmail,
      companyLogo,
      clientNameBilling,
      companyNameBilling,
      restaurantNameBilling,
      gstinBilling,
      phoneBilling,
      emailBilling,
      stateBilling: stateBilling.name,
      cityBilling: cityBilling.name,
      pincodeBilling,
      fullAddressBilling,
      countryBilling: "India",
      phoneExt: "+91",
      phoneExtBilling: "+91",
      joiningDate: getCurrentDate(),
      joiningTime: getCurrentTime(),
      theme: {
        primary: "#714bfa",
        secondary: "#f66187",
        tertiary: "#1f2544",
      },
      outlets: [
        {
          outletId: stringToURL(outletName),

          // outletLogo,
          outletName,
          outletPhone,
          outletPhoneExt: "+91",
          outletFullAddress,
          outletState: outletState.name,
          outletCity: outletCity.name,
          outletPincode,
          outletCountry: "India",
          outletCurrency: "₹",
          tables: [
            {
              id: uuidv4(),
              tableName: "Table 1",
              seatCount: 1,
              tableNo: "1",
            },
          ],
        },
      ],
    };

    dispatch(setInitialRestaurantConfig(data));
  }

  // function getCurrentLocation() {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         const latitude = position.coords.latitude;
  //         const longitude = position.coords.longitude;
  //         setoutletLatitude(latitude);
  //         setoutletLongitude(longitude);

  //         // You can now use latitude and longitude as needed, e.g., pass it to another function
  //         // or update your state in a React component
  //       },
  //       (error) => {
  //         if (error.code === error.PERMISSION_DENIED) {
  //           console.error("User denied Geolocation.");
  //           dispatch(setmessage({ type: "error", title: "Failed", message: "Enable your location and try again." }));
  //         } else {
  //           console.error("Error getting current location:", error);
  //         }
  //         // Optionally, prompt the user to retry getting the location
  //         // You can show a button or any other UI element for this purpose
  //         // For example, you can call `getCurrentLocation` again on button click
  //       }
  //     );
  //   } else {
  //     console.error("Geolocation is not supported by this browser.");
  //   }
  // }

  useEffect(() => {
    if (restaurantConfig) {
      navigate("/manage");
      setloading(false);
    } else if (!isAuthenticated) {
      navigate("/");
      setloading(false);
    } else {
      setloading(false);
    }
  }, []);

  if (loading) {
    return <SplashScreen />;
  }

  return (
    <div className="initial-setup">
      <div className="input-wrapper">
        <h3 className="mb-5">FINISH INITIAL SETUP</h3>

        <p className="info mb-3">
          Fill out all the fields required for the initial setup of your restaurant. All * marked fields are important
          as the data entered here will be used in your application, so please fill the correct data.
        </p>

        <div className="grid-input mb-5">
          <InputText
            value={restaurantName}
            label="Restaurant Name (that will display in the app)*"
            placeholder="Enter Restaurant Name"
            onChange={(e) => setrestaurantName(e.target.value)}
            validation="ne"
          />
          <InputText
            value={clientName}
            label="Your Full Name*"
            placeholder="Enter Your Full Name"
            onChange={(e) => setclientName(e.target.value)}
            validation="ne"
          />

          <InputText
            value={clientPhone}
            label="Your Phone Number*"
            placeholder="Enter Your Phone Number"
            onChange={(e) => phoneOnChange(e.target.value) && setclientPhone(e.target.value)}
            validation="ne"
          />

          <div>
            <InputText
              value={clientEmail}
              label="Your E-mail*"
              placeholder="Your E-mail"
              onChange={(e) => setclientEmail(e.target.value)}
              validation={loginEmailCheckbox ? "" : "email"}
              disabled={loginEmailCheckbox}
            />
            <InputCheckbox
              label="Use My Login E-mail"
              checked={loginEmailCheckbox}
              value={loginEmailCheckbox}
              onChange={(e) => {
                const checked = e.target.checked;
                checked ? setclientEmail(userData.email) : setclientEmail("");
                setloginEmailCheckbox(checked);
              }}
            />
          </div>
        </div>

        <div className="flex g-5 mb-3">
          <InputImage
            label="Company Logo*"
            value={""}
            onChange={(image) => setcompanyLogo(image)}
            fileSize={1048576 / 4}
          />
        </div>
        <p className="info mb-5">
          Logo image should be less than 256KB. Make sure that it should be a clear image. Your logo will be visible on
          the splash screen while opening the app and many more places.
        </p>

        <h3 className="mb-1">BILLING INFORMATION</h3>

        <h3 className="info mb-3">
          Please ensure all billing details are filled out accurately, as this information will be used to generate your
          invoice.
        </h3>
        <div className="grid-input mb-5">
          <InputText
            value={clientNameBilling}
            label="Your Name Used For Billing*"
            placeholder="Enter Your Name"
            onChange={(e) => setclientNameBilling(e.target.value)}
            validation="ne"
          />

          <InputText
            value={companyNameBilling}
            label="Enter Full Legal Name Of Your Company*"
            placeholder="Enter Your Company's Full Name"
            onChange={(e) => setcompanyNameBilling(e.target.value)}
            validation="ne"
          />

          <InputText
            value={restaurantNameBilling}
            label="Enter Full Legal Name Of Your Restaurant*"
            placeholder="Enter Your Restaurant's Full Name"
            onChange={(e) => setrestaurantNameBilling(e.target.value)}
            validation="ne"
          />

          <InputText
            value={gstinBilling}
            label="Your Company's GSTIN Number*"
            placeholder="Enter Your Company's GSTIN Number"
            onChange={(e) => setgstinBilling(e.target.value)}
            validation="ne"
          />

          <InputText
            value={phoneBilling}
            label="Your Phone Number*"
            placeholder="Enter Your 10 Digit Phone Number"
            onChange={(e) => phoneOnChange(e.target.value) && setphoneBilling(e.target.value)}
            validation="ne"
          />
          <div>
            <InputText
              value={emailBilling}
              label="Your E-mail That Will Be Used To Send The Invoice*"
              placeholder="Enter Your E-mail"
              onChange={(e) => setemailBilling(e.target.value)}
              validation={loginEmailCheckboxBilling ? "" : "email"}
              disabled={loginEmailCheckboxBilling}
            />
            <InputCheckbox
              label="Use My Login E-mail For Invoice"
              value={loginEmailCheckboxBilling}
              checked={loginEmailCheckboxBilling}
              onChange={(e) => {
                const checked = e.target.checked;
                checked ? setemailBilling(userData.email) : setemailBilling("");
                setloginEmailCheckboxBilling(checked);
              }}
            />
          </div>

          <InputSelect
            label="State*"
            placeholder="Search State*"
            options={stateIndia}
            itemKey="name"
            searchable
            value={stateBilling}
            onClickItem={(value) => setstateBilling(value)}
            validation="ne"
          />
          <InputSelect
            label="City*"
            placeholder="Search City*"
            options={stateBilling ? cityIndia[stateBilling.name] : []}
            itemKey="name"
            searchable
            value={cityBilling}
            onClickItem={(value) => setcityBilling(value)}
            disabled={!stateBilling}
            validation="ne"
          />
          <InputText
            label="Pincode*"
            placeholder="Enter Your Address Pincode"
            value={pincodeBilling}
            onChange={(e) => setpincodeBilling(e.target.value)}
            validation="ne"
          />
          <InputArea
            rows={5}
            style={{ gridRow: "span 2" }}
            label="Your Full Billing Address*"
            placeholder="Provide Your Complete Billing Address For Invoicing Purposes"
            value={fullAddressBilling}
            onChange={(e) => setfullAddressBilling(e.target.value)}
            validation="ne"
          />
        </div>

        <div className="grid-input mb-5"></div>

        <h3 className="mb-1">YOUR FIRST OUTLET</h3>
        <p className="info mb-3">
          Create your first outlet. You can add more outlets later once you finish the initial setup. You can create
          multiple users account and assign each of them to different outlets to manage menu and orders
        </p>

        {/* <div className="flex g-5 mb-3">
          <InputImage
            label="Outlet Image*"
            value={outletLogo}
            onChange={(image) => setoutletLogo(image)}
            fileSize={1048576 / 4}
          />
        </div>
        <p className="info mb-5">
          Outlet image should be less than 256KB. It should be a clear image. It will show up in your login outlet
          screen.
        </p> */}

        <div className="grid-input mb-5">
          <InputText
            label="Outlet Name (This name cannot be changed later but you can replace it with a New Outlet)*"
            placeholder="Enter Your Outlet Name"
            value={outletName}
            onChange={(e) => setoutletName(e.target.value)}
            validation="ne"
          />
          <InputText
            label="Outlet's Phone Number*"
            placeholder="Enter Outlet's 10 Digit Phone Number"
            value={outletPhone}
            onChange={(e) => phoneOnChange(e.target.value) && setoutletPhone(e.target.value)}
            validation="ne"
          />
          <InputSelect
            label="Outlet State*"
            placeholder="Search State"
            options={stateIndia}
            itemKey="name"
            searchable
            value={outletState}
            onClickItem={(value) => setoutletState(value)}
            validation="ne"
          />
          <InputSelect
            label="Outlet City*"
            placeholder="Search City"
            options={outletState ? cityIndia[outletState.name] : []}
            itemKey="name"
            searchable
            value={outletCity}
            onClickItem={(value) => setoutletCity(value)}
            disabled={!outletState}
            validation="ne"
          />
          <InputText
            label="Outlet Pincode*"
            placeholder="Enter Your Outlet Pincode"
            value={outletPincode}
            onChange={(e) => setoutletPincode(e.target.value)}
            validation="ne"
          />
          <div>
            {customTax ? (
              <InputText
                label="Enter your custom GST rate for this outlet (Enter only value excluding %)*"
                placeholder="Enter GST rate value"
                value={outletTax}
                onChange={(e) => setoutletTax(e.target.value)}
                validation="ne"
              />
            ) : (
              <InputSelect
                label={
                  <span>
                    Select the GST rate for this outlet*{" "}
                    <span className="primary pointer" onClick={() => setpopupTaxInfo(true)}>
                      Know more
                    </span>
                  </span>
                }
                placeholder="Select GST rate from the list"
                options={[
                  { name: "5%", value: "5" },
                  { name: "18%", value: "18" },
                ]}
                itemKey="name"
                value={outletTax ? outletTax.name : ""}
                onClickItem={(value) => setoutletTax(value)}
                validation="ne"
              />
            )}
            <InputCheckbox
              label="Use Custom GST Rate"
              checked={customTax}
              value={customTax}
              onChange={(e) => {
                const checked = e.target.checked;
                setoutletTax("");
                setcustomTax(checked);
              }}
            />
          </div>

          <InputArea
            rows={5}
            style={{ gridRow: "span 2" }}
            label="Your Full Outlet Address*"
            placeholder="Provide Your Complete Outlet Address"
            value={outletFullAddress}
            onChange={(e) => setoutletFullAddress(e.target.value)}
            validation="ne"
          />
        </div>

        {/* <InputCheckbox
          label="Accept home delivery"
          className="mb-3"
          value={acceptHomeDelivery}
          onChange={(e) => setacceptHomeDelivery(e.target.checked)}
        />
        {acceptHomeDelivery && (
          <>
            <div className="grid-input mb-3">
              <InputEdit
                value={outletLatitude}
                label="Outlet location (°N) Coordinate (Latitude)"
                onChange={(e) => setoutletLatitude(e.target.value)}
              />
              <InputEdit
                value={outletLongitude}
                label="Outlet location (°E) Coordinate (Longitude)"
                onChange={(e) => setoutletLongitude(e.target.value)}
              />
              <ButtonPrimary text="Use current location coordiantes" onClick={() => getCurrentLocation()} />
            </div>
            <p className="info mb-3">
              You can find the outlet coordinates by searching the coordinates of the outlet address on the internet or
              maps. The coordinates will be used if you want to use this app for home delivery as well in order to set
              the minimum distance of order acceptance (let's say you want to deliver around a distance of 5km from your
              outlet, so someone can only place the order if they are within the range). If you're in the outlet
              location, you can use the button to get the coordinates.
            </p>
          </>
        )} */}

        <div className="flexc">
          <p className="info mb-3">
            By clicking on the button you agree to our <a href="#">Terms and Conditions</a> and{" "}
            <a href="#">Privacy Policy</a>.
          </p>
          <ButtonPrimary text="Create your restaurant" onClick={onSave} />
        </div>
      </div>

      <PopupTaxInfo popupTaxInfo={popupTaxInfo} setpopupTaxInfo={setpopupTaxInfo} />
    </div>
  );
};

export default InitialSetup;
